import { DatePipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'utcToLocal'
})
@Injectable({
    providedIn: 'root',
})
export class UtcToLocalPipe implements PipeTransform {
    transform(utcDate: Date | string, format: string = ''): string {
        if (!utcDate) return '';

        let date: Date;

        // 判断utcDate是否为Date对象，如果是字符串则尝试将其转换为Date
        if (utcDate instanceof Date) {
            date = utcDate;
        } else if (typeof utcDate === 'string') {
            const parsedDate = Date.parse(utcDate); // 转换日期字符串为毫秒数
            if (isNaN(parsedDate)) {
                console.error(`Invalid date string: ${utcDate}`);
                return ''; // 返回空字符串以避免响应错误
            }
            date = new Date(parsedDate); // 将合法字符串转换为Date对象
        } else {
            console.error(`Invalid date input: ${utcDate}`);
            return ''; // 无法处理的类型
        }

        // 将UTC时间转换为本地时间
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

        const datePipe = new DatePipe('en-US');

        switch (format) {
            case 'short':
                return datePipe.transform(localDate, 'short') || '';
            case 'full':
                return datePipe.transform(localDate, 'full') || '';
            case 'timeOnly':
                return datePipe.transform(localDate, 'HH:mm:ss') || '';
            case 'dateOnly':
                return datePipe.transform(localDate, 'yyyy-MM-dd') || '';
            case 'medium':
            default:
                return datePipe.transform(localDate, 'yyyy-MM-dd HH:mm:ss') || '';
        }
    }
}